import React from "react";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { intl } from "../../../i18n/provider";
import SubNavItem from "./SubNavItem";

// ✅ import images once, use variables below
import addImg from "../../../assests/images/companiesLogos/add.PNG";
import creditImg from "../../../assests/images/companiesLogos/credit.png";
import g3Img from "../../../assests/images/companiesLogos/g33.png";
import roamingImg from "../../../assests/images/companiesLogos/roaming.png";

const SubNav = ({
  mobile,
  Jawwal3gLoading,
  JawwalRomLoading,
  JawwalMinLoading,
  isDarktheme,
}) => {
  const history = useHistory();
  const currentRoute = history?.location?.pathname?.split("/")[2];
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isDisabled = !(
    mobile.length === 10 || params.get("number")?.length === 10
  );
  const provider_Id = window.history?.state?.state?.provider_Id || "001";

  const handlePathChange = (newPath) => {
    history.push({
      pathname: newPath,
      search: params.toString(),
      state: history.location.state,
      provider_Id,
    });
  };

  return (
    <div
      className={`d-flex justify-content-around sub-nav ${
        isDarktheme && "dark"
      } my-2 jawwal-sub`}
    >
      <SubNavItem
        href={`/company/jawwalCredit/${mobile}`}
        routeKey="jawwalCredit"
        currentRoute={currentRoute}
        title={intl.formatMessage({ id: "addCreadit" })}
        logoSrc={addImg}
        isLoading={false}
        isDisabled={isDisabled}
        onClick={() => handlePathChange(`/company/jawwalCredit/${mobile}`)}
      />
      <SubNavItem
        href={`/company/jawwalMin/${mobile}`}
        routeKey="jawwalMin"
        currentRoute={currentRoute}
        title={intl.formatMessage({ id: "jawwalMin" })}
        logoSrc={creditImg}
        isLoading={JawwalMinLoading}
        isDisabled={isDisabled}
        onClick={() => {
          if (params.get("number")?.length === 10 || !params.get("number"))
            handlePathChange(`/company/jawwalMin/${mobile}`);
        }}
      />
      <SubNavItem
        href={`/company/jawwal3g/${mobile}`}
        routeKey="jawwal3g"
        currentRoute={currentRoute}
        title={intl.formatMessage({ id: "g3" })}
        logoSrc={g3Img}
        isLoading={Jawwal3gLoading}
        isDisabled={isDisabled}
        onClick={() => {
          if (params.get("number")?.length === 10 || !params.get("number"))
            handlePathChange(`/company/jawwal3g/${mobile}`);
        }}
      />
      <SubNavItem
        href={`/company/jawwalRom/${mobile}`}
        routeKey="jawwalRom"
        currentRoute={currentRoute}
        title={intl.formatMessage({ id: "Roaming" })}
        logoSrc={roamingImg}
        isLoading={JawwalRomLoading}
        isDisabled={isDisabled}
        onClick={() => handlePathChange(`/company/jawwalRom/${mobile}`)}
      />
    </div>
  );
};

const mapStateToProps = ({
  companies: {
    Jawwal3gLoading,
    JawwalRomLoading,
    JawwalMinLoading,
  },
  darkTheme: { isDarktheme },
}) => ({
  Jawwal3gLoading,
  JawwalRomLoading,
  JawwalMinLoading,
  isDarktheme,
});

export default connect(mapStateToProps)(SubNav);
